import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) return null;

    const emailRegex = /^[^@]+@[^@]+\.[^@]+$/;

    return emailRegex.test(value) ? null : { invalidEmail: true };
  };
}
